<div *ngIf='isReferenceYearListAvailable' class="subpage-single-component">
	<div class="referenceYear-companyOverview">
		<div class="selector-wrapper d-inline-flex align-items-center justify-content-between w-100 bg-light">
			<div class="select-container">
				<ng-select [clearable]="false"
						   [virtualScroll]='false'
						   class="custom variant select-dropdown"
						   [ngModel]='referenceYear'
						   [searchable]="false"
						   [items]='referenceYears'
						   (change)='changeReferenceYear($event)'
						   [dropdownPosition]='auto'
						   [class.divider]='false'>
					<!-- this is selected -->
					<ng-template ng-label-tmp let-item="item" let-clear="clear">
						<p class="ng-value-label">{{title}}</p>
					</ng-template>
					<!-- this is option -->
					<ng-template ng-option-tmp let-item="item">
						<div class="ng-option-label">
							<p class="list-title">Company Overview {{item}}</p>
						</div>
					</ng-template>
				</ng-select>
			</div>
		</div>
	</div>
</div>

<div *ngIf='data' class="wrapper-overflow subpage-single-component" [ngClass]="{'no-padding': key === 'manage_taxonomies_modal'}">
	<app-loader *ngIf="info?.loader"></app-loader>
	<div class="data-wrapper" #resize [ngStyle]="{'overflow': isDropdownClosed? 'hidden': 'unset'}">
		<div class="data-table" [ngClass]="{'overflow-dropdown': isDropdownClosed}">
			<div #header class="data-table-header d-flex flex-column">
				<div *ngIf='info' class="d-inline-flex justify-content-between w-100 mb-3">
					<div class="data-table-header-content" [ngClass]="{'auto': auto}">
						<span class="subtitle">{{subtitle}}</span>
						<span class="title">{{title}}</span>
					</div>
					<i class="ic-fullscreen-on"></i>
				</div>
				<div *ngIf='auto' class="table-title">
					{{data?.table?.title}}
				</div>
				<div *ngIf='!info && indicators'
					 class="d-inline-flex w-100 align-items-end subtitle">
					{{subtitle}}
				</div>

				<div *ngIf='!info && filters'
					 class="d-inline-flex w-100 align-items-end title">
					<span *ngIf="!isReferenceYearListAvailable">{{title}}</span>
				</div>
			</div>
			<table #table class="data-table-content">
				<thead>
					<tr *ngIf='isNameNotNull'>
						<th class="custom-table sticky first-col"
							rowspan="2"
							[attr.colspan]="header?.colonne?.length - 1"></th>
						<th class="custom-table"
							*ngFor="let header of data?.table?.header; let headerIndex = index"
							rowpsan="1"
							[attr.colspan]="header?.colonne?.length">
							<div class="custom-control" [class]="!data?.table?.mutuallyExclusion_columns ? 'custom-checkbox' : 'custom-radio no-label'" *ngIf='getColumnType(header?.name) ; else noCheckBoxHeader'>
								<input *ngIf='!data?.table?.mutuallyExclusion_columns'
									   type="checkbox"
									   class="custom-control-input"
									   id="columnHeader_checkbox-{{headerIndex}}"
									   [(ngModel)]="header.name"
									   [indeterminate]="columnStatusList[headerIndex] == 2"
									   (change)="onSelectedColumn(header?.name, headerIndex, data?.table?.mutuallyExclusion_columns)" />
								<input *ngIf='data?.table?.mutuallyExclusion_columns'
									   type="radio"
									   class="custom-control-input"
									   id="columnHeader-{{headerIndex}}"
									   [checked]='header.name'
									   (click)='onSelectedColumn(header?.name, headerIndex, data?.table?.mutuallyExclusion_columns)' />
								<label *ngIf='!data?.table?.mutuallyExclusion_columns' class="custom-control-label" for="columnHeader_checkbox-{{headerIndex}}"><span class="customLbl" *ngIf='info?.component_type === "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili"'>{{headerIndex}}</span></label>
								<label *ngIf='data?.table?.mutuallyExclusion_columns' class="custom-control-label" for="columnHeader-{{headerIndex}}"></label>
							</div>
							<ng-template #noCheckBoxHeader>
								<span>{{ header.name }}</span>
							</ng-template>
						</th>
					</tr>
					<tr *ngIf='info?.component_type !== "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili"'>
						<th *ngIf='auto && !isNameNotNull && !isSimpleTable'
							class=" custom-table sticky first-col"
							rowspan="2"
							[attr.colspan]="header?.colonne?.length"></th>
						<ng-container *ngFor="let header of data?.table?.header; let tableIndex = index">
							<th class="custom-table"
								*ngFor="let col of header?.colonne; let headerIndex = index"
								rowpsan="1"
								[attr.colspan]="1">
								<div *ngIf="isPercentageColumn(col)" class="dropdown">
									<button class="btn text-accent p-0" type="button" id="dropdownPercentage" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										Change Value (%)
									</button>
									<div ngbDropdown class="dropdown">
										<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownPercentage">
											<a class="dropdown-item" (click)="onChangePercentageColumnValue(tableIndex, headerIndex, '0')">Set 0</a>
											<a class="dropdown-item" (click)="onChangePercentageColumnValue(tableIndex, headerIndex, '50')">Set 50</a>
											<a class="dropdown-item" (click)="onChangePercentageColumnValue(tableIndex, headerIndex, '100')">Set 100</a>
											<div>
												<input [(ngModel)]="per" type="number">
												<button class="btn-primary" (click)="onChangePercentageColumnValue(tableIndex, headerIndex, per )">change %</button>
											</div>
										</div>
									</div>

								</div>
								<span *ngIf="!isPercentageColumn(col)">{{col}}</span>

							</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let body of data?.table?.body | slice:0:viewMore;  let tableIndex = index"
						[ngClass]="{'bg-light-grey' : body.is_selected}">
						<th class="sticky custom-table"
							[ngClass]="{'wrap' : body?.name?.length > 30, 'first-col' : info?.component_type === 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili'}"
							*ngIf='info?.component_type === "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili" &&
							!isSimpleTable'>
							<div class="custom-control custom-checkbox" *ngIf='info?.component_type === "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili"'>
								<input type="checkbox"
									   class="custom-control-input"
									   id="privateMode_checkbox-{{tableIndex}}"
									   [checked]='body.is_selected === undefined ? true : body.is_selected'
									   [indeterminate]="rowStatusList[tableIndex] == 2"
									   (click)='onSelectedRow(body, tableIndex, "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili")'>
								<label class="custom-control-label customLbl" for="privateMode_checkbox-{{tableIndex}}">{{body?.name}}</label>
								<!-- && info?.component_type !== 'tabella_con_righe_colonne_selezionabili' -->
							</div>
						</th>
						<th class="sticky custom-table"
							[ngClass]="{'wrap' : body?.name?.length > 30, 'first-col' : info?.component_type !== 'tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili'}"
							*ngIf='info?.component_type !== "tabella_con_righe_selezionabili" &&
							info?.component_type !== "tabella_con_righe_colonne_selezionabili" &&
							info?.component_type !== "tabella_semplice_prima_colonna_fissata_righe_colonne_selezionabili" &&
							!isSimpleTable'>
							{{body?.name}}
						</th>
						<th class="sticky first-col cell-selector custom-table"
							[ngClass]="{'bg-light-grey' : body.is_selected}"
							*ngIf='info?.component_type === "tabella_con_righe_selezionabili" ||
							info?.component_type === "tabella_con_righe_colonne_selezionabili"'>
							<div class="custom-control custom-radio no-label">
								<input type="radio"
									   class="custom-control-input"
									   id="privateMode-{{tableIndex}}"
									   [checked]='body.is_selected'
									   (click)='onSelectedRow(body, tableIndex)'>
								<label class="custom-control-label" for="privateMode-{{tableIndex}}"></label>
								<!-- && info?.component_type !== 'tabella_con_righe_colonne_selezionabili' -->
							</div>
						</th>
						<td class="custom-table"
							*ngFor="let cell of body?.values; let cellIndex = index"
							[ngSwitch]="cell.cell_type"
							[class.bg-light-grey]="cell.is_checked">
							<div *ngSwitchCase="'cella_true_false'" class="">
								<app-cell-boolean [data]='cell'
												  [cellIndex]='cellIndex'
												  [tableIndex]='tableIndex'
												  (sendSelectedCellValue)='onCell($event, body, cellIndex)'></app-cell-boolean>
							</div>
							<div *ngSwitchCase="'cella_dropdown'" class="single-cell">
								<app-cell-dropdown [data]='cell'
												   (sendSelectedCellValue)='onCell($event)'
												   (isDropdownClosed)='handleOverflowOnTable($event)'></app-cell-dropdown>
							</div>
							<div *ngSwitchCase="'cella_edit_manuale'">
								<app-cell-manual-edit [data]="cell"
													  [withModal]="checkWithModal(key)"
													  (sendSelectedCellValue)="onCell($event)"></app-cell-manual-edit>
							</div>
							<div *ngSwitchCase="'cella_edit_con_memoria'" class="single-cell" [class.obscure]='cell.obscure_cell'>
								<app-cell-manual-edit
									[data]="cell"
									[memoryCells_permanent_memory]="memoryCells_permanent_memory"
									(sendSelectedCellValue)="onCell($event)"
								></app-cell-manual-edit>
							</div>
							<div *ngSwitchCase="'cella_edit_true_false'">
								<app-cell-boolean [data]="cell"
												  (sendSelectedCellValue)="onCell($event, body, cellIndex)"
												  [cellIndex]='cellIndex'
												  [tableIndex]='tableIndex'></app-cell-boolean>
							</div>
							<div class="{{cell.type}} d-flex flex-column p-3" *ngSwitchCase="'cella_subtool5'">
								<span>{{cell.value1 | truncate : cell.nDecimals}}</span>
								<span>{{cell.value2 | truncate : cell.nDecimals}}</span>
							</div>
							<div *ngSwitchDefault class="default-cell" [class.obscure]='cell.obscure_cell' [class.bold]='cell.is_bold'>
								{{cell.value | truncate : cell.nDecimals }}
								<button *ngIf="cell.description !== null" type="button"
										class="btn info-tooltip"
										ngbTooltip="{{cell.description}}"
										placement='right'
										[autoClose]="'outside'"
										triggers='hover'>
									<i class="ic-info info"></i>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="my-3" *ngIf='data?.table?.body && data?.table?.body.length > 20'>
			<a class="text-accent" (click)='getAllTablesRow()'>{{viewMore > 20 ? 'View less' : 'View more'}}</a>
		</div>
		<div class="my-3" *ngIf='data?.table?.foot'>
			<small class="text-secondary">{{data?.table?.foot}}</small>
		</div>
	</div>
</div>
<ng-content></ng-content>
<app-table-skeleton *ngIf='!data'></app-table-skeleton>
